import DuraflowCategoryPage from '@/pages/equipamentos-e-componentes/components/DuraflowCategoryPage';
import useSeo from '@/hooks/useSeo';

export default function AcessoriosPage() {
  useSeo({
    title: 'Acessórios e Conexões Hidráulicas | Duraflow',
    description: 'Conexões, adaptadores, flanges, engates rápidos, filtros, reservatórios e trocadores de calor para circuitos hidráulicos industriais.',
    keywords: 'conexões hidráulicas, acessórios hidráulicos, engates rápidos, filtros hidráulicos, componentes hidráulicos, DURAFLOW, Grupo Pilar',
    canonical: 'https://www.pilarmanutencao.com.br/acessorios-conexoes',
    ogUrl: 'https://www.pilarmanutencao.com.br/acessorios-conexoes',
    ogImage: '/images/EQUIPAMENTOS-E-COMPONENTES/NOSSOS-PRODUTOS/ACESSORIOS-E-CONEXOES/CARD/ACESSORIOS-E-CONEXOES.webp',
  });

  return (
    <DuraflowCategoryPage
      title="Acessórios e Conexões"
      subtitle="Conexões, adaptadores, flanges, quick connects, filtros e todo o necessário para montagem e manutenção de circuitos hidráulicos."
      heroImage="/images/EQUIPAMENTOS-E-COMPONENTES/NOSSOS-PRODUTOS/ACESSORIOS-E-CONEXOES/HERO/HERO-ACESSORIOS-E-CONEXOES.webp"
      heroImageAlt="Acessórios e conexões hidráulicas industriais"
      description="A linha de acessórios e conexões DURAFLOW completa todo o circuito hidráulico com peças de qualidade industrial. Desde simples adaptadores até conjuntos de filtros, reservatórios, trocadores de calor e quick connects, oferecemos tudo o que é necessário para uma instalação segura, estanque e durável."
      applications={[
        'Montagem de novos circuitos hidráulicos',
        'Manutenção e reparo de sistemas existentes',
        'Adaptação e retrofit de máquinas',
        'Sistemas móveis e portáteis',
        'Indústria de construção e mineração',
        'Oficinas de manutenção hidráulica',
      ]}
      types={[
        {
          title: 'Conexões e Adaptadores',
          description:
            'Niples, cotovelos, tees, reduções e adaptadores macho/fêmea em aço carbono, inox e latão com roscas NPT, BSP, JIC e métricas.',
        },
        {
          title: 'Flanges e Conexões SAE',
          description:
            'Flanges SAE split e flange completo com parafusos e anéis de vedação para conexões de alta pressão em bombas e blocos manifold.',
        },
        {
          title: 'Engates Rápidos',
          description:
            'Quick connects pneumáticos e hidráulicos para conexão rápida e segura de mangueiras e equipamentos móveis sem perda de fluido.',
        },
        {
          title: 'Filtros e Elementos',
          description:
            'Filtros de sucção, retorno, linha de pressão e respiradores com elementos filtrantes de papel, malha e fibra de vidro em diversas micronagens.',
        },
        {
          title: 'Reservatórios e Acessórios',
          description:
            'Reservatórios de óleo em aço carbono e inox, com tampas, respiros, níveis de óleo, drenos e aquecedores para diferentes capacidades.',
        },
        {
          title: 'Trocadores de Calor',
          description:
            'Trocadores de calor a placa e tubo para refrigeração do óleo hidráulico, mantendo a temperatura operacional dentro da faixa ideal.',
        },
      ]}
      differentials={[
        'Amplo estoque de conexões nas bitolas e roscas mais utilizadas no mercado industrial',
        'Filtros e elementos compatíveis com os principais padrões de fabricantes nacionais e importados',
        'Quick connects com vedação por esfera e plano para diferentes pressões e fluidos',
        'Montagem de kits de manutenção sob medida conforme lista de peças do cliente',
        'Consultoria técnica para seleção de conexões adequadas à pressão e compatibilidade de fluido',
      ]}
    />
  );
}